// extracted by mini-css-extract-plugin
module.exports = {"colourPrimaryMain":"#1565c0","colourSecondaryMain":"#0d47a1"};